module.exports = __webpack_public_path__ + "img/Cracked Stone.4c018318.png";